export const items = [
    {
        id: '111',
        title: 'Shopping at the supermarket',
        done: false
    },
    {
        id: '222',
        title: 'Take the kids out of school',
        done: true
    },
    {
        id: '333',
        title: 'Pick the amazon package from the post office',
        done: false
    },
    {
        id: '444',
        title: 'Grab a cup of coffee with jane from the office',
        done: false
    },
    {
        id: '555',
        title: 'Run 2 km at the park',
        done: false
    }
];
